module.exports = __webpack_public_path__ + "img/mbBanner13.9971b9da.png";